import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

import { KpiLayout } from "components/OverviewPages/KPIs/KpiLayout";
import Tooltip from "@mui/material/Tooltip";

import { getSubtractedDateFromNow } from "core/datetime";
import { useLazyFetchGet } from "hooks/fetch/useLazyFetchGet";
import { CaseManagementParamsContext } from "contexts/CaseManagementParamsContext";

import { ReactComponent as AlarmsIcon } from "assets/img/KPIIcons/alarms.svg";
import { styled } from "@mui/material/styles";

export function FleetCaseMeanResponseTimeKpi({
  expanded,
  fleet,
  site,
  machine
}) {
  const [meanTime, setMeanTime] = useState();
  const history = useHistory();
  const { onSetTableStateFromDefault } = useContext(
    CaseManagementParamsContext
  );

  const ninetyDaysAgoDate = getSubtractedDateFromNow(90);

  const url = site?.id
    ? `cases/mean_response_days?close_date__gte=${ninetyDaysAgoDate}&site_id=${site.id}`
    : machine?.id
    ? `cases/mean_response_days?close_date__gte=${ninetyDaysAgoDate}&machine_id=${machine.id}`
    : `cases/mean_response_days?close_date__gte=${ninetyDaysAgoDate}`;

  const { loading, getCallback } = useLazyFetchGet(url, ({ mean }) => {
    setMeanTime(Math.floor(mean ?? 0));
  });

  useEffect(() => {
    if (expanded && meanTime === undefined) {
      if (fleet || site || machine) {
        getCallback();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meanTime, expanded, fleet, site, machine]);

  const isCurrentPathForCaseManagement = history.location.pathname.includes(
    "/pages/case-management"
  );

  const onCaseSummaryClicked = () => {
    const shortCutFilter = {};
    if (site?.id && site?.name) {
      shortCutFilter.Site = [{ name: site.name, id: site.id }];
    } else if (machine?.id && machine?.name) {
      shortCutFilter.Machine = [{ name: machine.name, id: machine.id }];
    }

    onSetTableStateFromDefault({
      filters: shortCutFilter,
      pageIndex: 0
    });

    if (!isCurrentPathForCaseManagement) history.push("/pages/case-management");
  };

  return (
    <KpiLayout
      title="Case Response Time"
      loading={loading || typeof meanTime !== "number"}
      Icon={AlarmsIcon}
      cursorEnable={!isCurrentPathForCaseManagement}
      onClickEvent={onCaseSummaryClicked}
    >
      <KpiBody>
        <Tooltip title="Mean response time between the case opening and first inspection">
          <KpiMeanTime>{meanTime} days</KpiMeanTime>
        </Tooltip>
      </KpiBody>
    </KpiLayout>
  );
}

const KpiBody = styled("div")`
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;
  height: 48px;
`;

const KpiMeanTime = styled("span")`
  color: #485057;
`;

FleetCaseMeanResponseTimeKpi.propTypes = {
  expanded: PropTypes.bool.isRequired,
  fleet: PropTypes.bool,
  site: PropTypes.object,
  machine: PropTypes.object
};
